/* Fluffberry cart add-on: adds the product and re-renders the Dawn cart drawer. */
(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* Copy helper: prefers the async clipboard API, falls back to a
     hidden textarea + execCommand where it is unavailable or blocked. */
  async function copyText(text) {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        return true;
      }
    } catch (err) {
      /* fall through to the legacy path */
    }

    try {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;pointer-events:none;';
      document.body.appendChild(ta);
      ta.select();
      const ok = document.execCommand('copy');
      ta.remove();
      return ok;
    } catch (err) {
      return false;
    }
  }

  function selectText(el) {
    try {
      const range = document.createRange();
      range.selectNodeContents(el);
      const sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
    } catch (err) {
      /* selection is a nicety; ignore if unsupported */
    }
  }

  /* Tap the discount code to copy it. */
  document.addEventListener('click', async (event) => {
    const chip = event.target.closest('[data-fb-copy]');
    if (!chip) return;

    const code = chip.dataset.fbCopy;
    const textEl = chip.querySelector('.fb-code__chip-text') || chip;

    if (!(await copyText(code))) {
      // Could not copy (insecure context, permission denied, no focus).
      // Select the code instead so it can still be copied by hand, rather
      // than leaving the tap with no result at all.
      selectText(textEl);
      return;
    }
    if (chip.dataset.fbRestore === undefined) chip.dataset.fbRestore = textEl.textContent;
    textEl.textContent = chip.dataset.fbCopied || chip.dataset.fbRestore;
    chip.classList.add('is-copied');

    clearTimeout(chip._fbTimer);
    chip._fbTimer = setTimeout(() => {
      textEl.textContent = chip.dataset.fbRestore;
      chip.classList.remove('is-copied');
    }, 2000);
  });

  document.addEventListener('click', async (event) => {
    const btn = event.target.closest('[data-fb-addon]');
    if (!btn || btn.disabled) return;
    event.preventDefault();

    const drawer = document.querySelector('cart-drawer');
    const label = btn.textContent;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    // Status text comes from the theme's locale file via data attributes.
    btn.textContent = btn.dataset.fbAdding || label;

    try {
      const sections =
        drawer && typeof drawer.getSectionsToRender === 'function'
          ? drawer.getSectionsToRender().map((s) => s.id)
          : [];

      const res = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(btn.dataset.fbAddon), quantity: 1 }],
          sections,
          sections_url: window.location.pathname,
        }),
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || 'Could not add item');

      if (drawer && data.sections && typeof drawer.renderContents === 'function') {
        drawer.renderContents(data);
      } else {
        window.location.href = `${root}cart`;
      }
    } catch (err) {
      console.error('[fb-addon]', err);
      btn.textContent = btn.dataset.fbFailed || label;
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      return;
    }
    btn.textContent = label;
  });
})();
